export const arrowUpSearchSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0002 18.75L12.0002 5.25M12.0002 5.25L6 11.3524M12.0002 5.25L18 11.3526" class="stroke" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
